export const MenuTitles = [
    {
        title: "Project",
        display: "Project",
        submenu: [
            {
                title: "description", 
                display: "Description"
            },
            {
                title: "engineering",
                display: "Engineering"
            },
            {
                title: "implementation", 
                display: "Implementation"
            },
            {
                title: "results", 
                display: "Results"
            }
        ]
    },{
        title: "Wet Lab",
        display: "Wet Lab",
        submenu: [
            {
                title: "parts-collection", 
                display: "Parts Collection"
            },
            {
                title: "experiments",
                display: "Experiments"
            },
            {
                title: "safety", 
                display: "Safety"
            }, 
            {
                title: "notebook", 
                display: "Notebook"
            }
        ]
    },{
        title: "Team",
        display: "Team",
        submenu: [
            {
                title: "team", 
                display: "Our Team"
            },
            {
                title: "attributions",
                display: "Attributions"
            },
            {
                title: "contribution", 
                display: "Our Contribution"
            }
        ]
    },{
        title: "human-practices",
        display: "Human Practices",
    }, {
        title: "education",
        display: "Education",
    }

]